// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title {\n  background: linear-gradient(-45deg, #ee7752, #e73c7e, #34abd6, #46ccad);\n  color: #ffffff !important;\n  padding: 16px;\n  background-size: 400% 400%;\n  animation: gradient 15s ease infinite; }\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%; }\n  50% {\n    background-position: 100% 50%; }\n  100% {\n    background-position: 0% 50%; } }\n\n.wrap-fa {\n  display: inline-block;\n  padding-right: 10px; }\n", ""]);
// Exports
module.exports = exports;
